<template>
  <main>
    <section class="wrapper align-items-center f-column min-win-height">
      <h2 class="font-center pr-2 pl-2">Nahrajte fotografie vozidla</h2>

      <div class="container-860 mb-children-2">
        <!-- Global error -->
        <div v-if="model.save.attempted">
          <div class="snack-bar orange has-error mb-1" v-if="errors.includes('FE015')">
            <p class="font-white">{{ errorMsg.FE015 }}</p>
          </div>
          <div class="snack-bar orange has-error" v-if="errors.includes('FE014')">
            <p class="font-white">{{ errorMsg.FE014 }}</p>
          </div>
        </div>

        <!-- Upload container -->
        <div class="container-full container-white">
          <div class="container-full mb-children-2">

            <div class="width-10 mb-children-2" v-for="(item,index) in inspectionResponse.inspectionPhotos"
                 :key="index">
              <h3 class="mb-1"> {{ photoDesc[item.type.toUpperCase()] }}
                {{requiredText(item.type)}}</h3>
              <div v-if="item.type==='clock' && item.showOdometer" class="input-box-holder" v-has-value="odometerReading" v-validate="errors">
                <div class="input-box">
                  <input ref="OdometerReading" v-model="odometerReading" id="odometer-reading" type="tel">
                  <label for="odometer-reading">Počet najazdených km</label>
                  <tooltip>
                    <h3 class="mb-2">Počet najazdených km</h3>
                    <p class="mb-2">Uveďte aktuálny stav najazdených kilometrov.</p>
                  </tooltip>
                </div>
                <div class="validation-output">
                  <div class="error" id="FE022">{{ errorMsg.FE022 }}</div>
                </div>
              </div>
              <div class="snack-bar gray mb-3 mb-2-768" v-if="item.maximumPictures > 1">
                <div class="flex align-items-center">
                  <em class="icon icon--info-white mr-1"></em>
                  <p class="font-white">
                    Maximálny počet fotografií: {{ item.maximumPictures }}
                  </p>
                </div>
              </div>
              <upload :requiredFile="item"></upload>
            </div>
            <div class="input-box-holder" v-has-value="email" v-validate="errors">
              <div class="input-box">
                <input ref="Email" v-model="email" id="email" type="email">
                <label for="email">E-mail pre doručenie potvrdenia</label>
                <tooltip>
                  <h3 class="mb-2">E-mail</h3>
                  <p class="mb-2">E-mailová adresa pre doručenie potvrdenia o úspešnom uložení fotografií</p>
                </tooltip>
              </div>
              <div class="validation-output">
                <div class="error" id="FE007">{{ errorMsg.FE007 }}</div>
                <div class="error" id="FE008">{{ errorMsg.FE008 }}</div>
                <div class="error" id="FE021">{{ errorMsg.FE021 }}</div>
              </div>
            </div>
            <check-box ref="saveForLaterGDPR" v-model="saveForLaterGDPR" :errors="errors" tabindex="0">
              <p class="mb-2 font-black">
                Súhlasím so spracovaním vyššie uvedenej e-mailovej adresy pracovníkmi
                Unionu za účelom aktivít súvisiacich s dokončením tejto samoobhliadky.
              </p>
              <template slot="validations">
                <div class="error" id="FE020">{{ errorMsg.FE020 }}</div>
              </template>
            </check-box>
            <p class="font-black">
              Odoslaním tohto formulára potvrdzujem, že odoslané fotografie sú fotografiami poisteného
              vozidla a boli vyhotovené najskôr 3 dni pred a najneskôr 7 dní po dni začiatku poistenia.
            </p>
          </div>
        </div>
      </div>

      <!-- CTA buttons -->
      <div class="cta-buttons width-10 f-center mb-8 priority-6">
        <div class="width-10 width-9-768 f-center mr-children-2 justify-content-end-768 align-items-center-768">
          <button @click="$router.goToStep(2)" class="button-white button-border-gray previous">
            <em class="mr-1 icon icon--arrow-left"></em>
            <div>Späť</div>
          </button>

          <button
            class="button-red continue"
            @click="saveFiles"
            v-scroll-to-error
          >
            Dokončiť
            <em class="desktop-arrow ml-2 icon icon--arrow-right"></em>
            <em class="mobile-arrow icon icon--arrow-right-mobile" style="vertical-align: middle;"></em>
          </button>
        </div>
      </div>

      <!-- Footer -->
      <transparent-footer></transparent-footer>
    </section>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

import { errorMsg, photoDesc } from '@/enums';

export default {
  name: 'Step3',
  data() {
    return {
      photoDesc, errorMsg,
    };
  },
  computed: {
    ...mapGetters({
      inspectionResponse: 'getInspectionResponse',
      model: 'getModel',
      errors: 'getErrors',
    }),
    email: {
      get() {
        return this.$store.state.insurerEmail;
      },
      set(value) {
        if (value.length === 0) {
          value = null;
        }
        this.$store.commit('SET_INSUREREMAIL', value);
        this.$store.dispatch('validateEmail');
      },
    },
    odometerReading: {
      get() {
        return this.$store.state.odometerReading;
      },
      set(value) {
        if (value.length === 0) {
          value = null;
        }
        this.$store.commit('SET_ODOMETER_READING', value);
        this.$store.dispatch('validateOdometerReading');
      },
    },
    saveForLaterGDPR: {
      get() {
        return this.$store.state.saveForLaterGDPR;
      },
      set(value) {
        this.$store.commit('SET_SAVEFORLATERGDPR', value);
      },
    },
  },
  methods: {
    requiredText(type) {
      let outputText;
      switch (type) {
        case 'damages':
          outputText = '(ak existujú)';
          break;
        case 'security':
          outputText = '(mechanické, ak sú súčasťou vozidla)';
          break;
        case 'additionalEquipment':
          outputText = '(ak je súčasťou vozidla)';
          break;
        default:
          outputText = '(povinné)';
      }
      return outputText;
    },
    async saveFiles() {
      await this.$store.commit('SET_ATTEMPTED', true);
      await this.$store.dispatch('validateStep');
      if (this.errors.length === 0) {
        this.$store.dispatch('saveFiles');
        this.$router.goToStep(4);
      }
    },
  },
  mounted() {
    this.$refs.saveForLaterGDPR.$el.addEventListener('keypress', (e) => {
      if (e.code === 'Space' || e.code === 'Enter') {
        this.$store.commit('SET_SAVEFORLATERGDPR', !this.saveForLaterGDPR);
      }
    });

    this.$refs.Email.addEventListener('focusout', () => {
      this.$store.dispatch('validateEmail');
    });

    if (Object.prototype.hasOwnProperty.call(this.$refs, 'OdometerReading')) {
      this.$refs.OdometerReading[0].addEventListener('focusout', () => {
        this.$store.dispatch('validateOdometerReading');
      });
    }
  },
  beforeCreate() {
    this.$store.commit('SET_STEP', 3);
    this.$store.commit('SET_LASTSTEP', 3);
  },
};
</script>
